import { render, staticRenderFns } from "./productModelSummary.vue?vue&type=template&id=6b715b7a&scoped=true&"
import script from "./productModelSummary.vue?vue&type=script&lang=js&"
export * from "./productModelSummary.vue?vue&type=script&lang=js&"
import style0 from "./productModelSummary.vue?vue&type=style&index=0&id=6b715b7a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b715b7a",
  null
  
)

export default component.exports